import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "map"]
  static values = { private: Boolean }

  mapTargetConnected() {
    this.loadMap();
  };

  setEventHandlers(map) {
    // redefine panOnFocus from default 
    L.Marker.addInitHook(function () {
      this._panOnFocus = function () {
        if (!map) { return; }

        var anchor = map._size.divideBy(4);
        map.panInside(this._latlng, {
          paddingTopLeft: anchor,
          paddingBottomRight: anchor
        });
      };
    });

    document.body.addEventListener('keydown', (event) => {
      if ((event.target.classList.contains('marker-cluster')) && (event.key == 'Enter')) {
        event.target.click();
      }
      if (event.key == 'Escape') {
        if (map._popup && map._popup.options.closeOnEscapeKey) {
          map.closePopup();
        }
      }
    });
  }

  maxZoomLevel() {
    if (this.privateValue == true) {
      return 20;
    } else {
      return 11;
    }
  }

  initializeMap() {
    var map = L.map('map', {
      zoomControl: false,
      zoomDelta: 0.5,
      zoomSnap: 0.5
    });

    L.control.zoom({ position: 'topright' }).addTo(map);
    L.control.scale({ position: 'bottomright' }).addTo(map);

    this.setEventHandlers(map);

    // center map in jordan for now
    map.setView([37.68167333333333, 32.66648166666666], 6);
    L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
    	attribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
      maxNativeZoom: 18,
      maxZoom: this.maxZoomLevel()
    }).addTo(map);

    map.on('popupopen', function (popup) {
      // focus the first link in the popup
      popup.popup._container.querySelector('[href]').focus();
    });

    // return focus to the icon we started from before opening the pop up
    map.on('popupclose', function (popup) {
      popup.popup._source._icon.focus();
    });

    return map;
  }

  noItems() {
    var svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svgElement.setAttribute('xmlns', "http://www.w3.org/2000/svg");
    svgElement.setAttribute('viewBox', "0 0 300 100");
    svgElement.setAttribute('style', "font-size: 1.3rem; background-color: rgba(0,0,0,.5);")
    svgElement.innerHTML = '<title>These objects have not yet been mapped</title><text x="30" y="20" fill="white">The objects on this page</text><text  x="20" y="50" fill="white">have not yet been mapped.</text>';
    return svgElement;
  }

  tooManyItems() {
    var svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svgElement.setAttribute('xmlns', "http://www.w3.org/2000/svg");
    svgElement.setAttribute('viewBox', "0 0 300 100");
    svgElement.setAttribute('style', "font-size: 1rem; background-color: rgba(0,0,0,.5);")
    svgElement.innerHTML = '<title>Too many items</title><text x="20" y="20" fill="white">This map cannot display more than</text><text x="10" y="50" fill="white">1000 items at once. Please narrow your</text><text x="40" y="80" fill="white">search criteria and try again.</text>';
    return svgElement;
  }


  checkBounds(map, markers) {
    if (OBJ_GEOGSON.features.length == 0) {
      var svgElementBounds = [[50, 53], [30, 3]];
      L.svgOverlay(this.noItems(), svgElementBounds).addTo(map);
      map.fitBounds(svgElementBounds);
    } else if (OBJ_GEOGSON.features.length > 1000) {
      console.log(OBJ_GEOGSON.features.length)
      var svgElementBounds = [[50, 53], [30, 3]];
      L.svgOverlay(this.tooManyItems(), svgElementBounds).addTo(map);
      map.fitBounds(svgElementBounds);
    } else {
      map.fitBounds(markers.getBounds(), { padding: [50, 50], maxZoom: this.maxZoomLevel() });
    }
  }

  populateMap(map) {
    console.log('populating map');
    var markers = L.markerClusterGroup({
      animate: true,
      zoomToBoundsOnClick: true,
      iconCreateFunction: function (cluster) {
        var childCount = cluster.getChildCount();

        var c = ' marker-cluster-';
        if (childCount < 10) {
          c += 'small';
        } else if (childCount < 100) {
          c += 'medium';
        } else {
          c += 'large';
        }
        var ariaLabel = ' objects clustered near ' + cluster.getLatLng();
        var clusterIcon = new L.DivIcon({
          html: '<div>' + childCount + '<span class="visually-hidden">' + ariaLabel + '</span></div>',
          className: 'marker-cluster' + c,
          iconSize: new L.Point(40, 40)
        });
        return clusterIcon;
      }
    });

      var newIcon = L.icon({
      iconUrl: marker_icon,
      iconSize: [24, 41],
      iconAnchor: [12, 41],
      shadowUrl: marker_shadow,
      });

    var object_json = L.geoJSON(OBJ_GEOGSON, {
      pointToLayer: function (geoJsonPoint, latlng) {
        var objectName = geoJsonPoint.properties.siglum;
        var ariaLabel = ' marker for ' + objectName + ' at ' + latlng;
        return L.marker(latlng, {
          icon: newIcon
        });
      },
      onEachFeature: function (feature, layer) {
        var popup = L.popup({
          content: "<h2 class='h6 fw-bold'><a href='/inscriptions/" + feature.properties.id + "' data-turbo='false'>" + feature.properties.siglum + "</a></h3>",
          maxWidth: 200,
          autoClose: true,
          closeOnEscapeKey: true,
          interactive: true,
          closeButton: true,
        });
        layer.bindPopup(popup);
      }
    });
    markers.addLayer(object_json);
    markers.on('spiderfied', function (a) {
      // focus the first link in the spiderfied popup
      console.log(a.markers[0].getElement());
      a.markers[0].getElement().focus();
    });
    if (OBJ_GEOGSON.features.length <= 1000) {
      map.addLayer(markers);
    }

    this.checkBounds(map, markers);
  }

  loadMap() {
    var container = L.DomUtil.get('map');
    if (container != null) {
      container._leaflet_id = null;
    }
    var map = this.initializeMap();
    this.populateMap(map);
    return map;
  }
}